<template>
  <div>
    <Multiselect
      class="multiselect-custom-input"
      v-model="value"
      :close-on-select="true"
      :options="options"
      :loading="loading"
      :searchable="true"
      :disabled="isDisabled"
    />
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';

export default {
  props: ['modelValue', 'idBrand', 'selected', 'isDisabled'],
  emits: ['onChange'],
  components: {
    Multiselect
  },
  watch: {
    modelValue() {
      this.value = this.modelValue;
    },
    selected() {
      this.selectedValue = parseInt(this.selected);
      this.value = this.selectedValue;
    },
    value() {
      this.$emit('onChange', this.value);
    },
    idBrand() {
      this.getOptions();
    }
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      let filters = undefined;

      if (this.idBrand) {
        filters = {
          idBrand: this.idBrand
        };
      }

      this.loading = true;
      this.$api
        .get('api/affiliate/all', filters)
        .then((res) => {
          this.loading = false;
          this.options = res.data.map((b) => {
            return { value: b.id, label: '(' + b.token + ') ' + b.name };
          });
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    }
  },
  data() {
    return {
      loading: false,
      value: null,
      options: [],
      selectedValue: null
    };
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
